import { render, staticRenderFns } from "./coalsearchhx.vue?vue&type=template&id=2c1e95c4&scoped=true"
import script from "./coalsearchhx.vue?vue&type=script&lang=js"
export * from "./coalsearchhx.vue?vue&type=script&lang=js"
import style0 from "./coalsearchhx.vue?vue&type=style&index=0&id=2c1e95c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e95c4",
  null
  
)

export default component.exports